export default "__VITE_ASSET__CcSJW$HH__"